import { Autocomplete, Avatar, Grid, IconButton, TextField, Tooltip, Typography, useMediaQuery } from '@mui/material'
import React, { useContext, useEffect, useMemo, useState } from 'react'
import { WhatsappCampaignContext, WhatsappCampaignContextPayload } from '../../../context/whatsappCampaignContext'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import styles from './../../../assets/styles/componentStyles/whatsappCampaignStyles/whatsappCampaignAnalysisStyle.module.scss'
import circularStyle from './../../../assets/styles/componentStyles/whatsappCampaignStyles/whatsappCampaignStyle.module.scss'
import datePickerStyles from "../../../assets/styles/componentStyles/callAnalysisStyles/callAnalysisAudio.module.scss";
import feedbackStyles from "../../../assets/styles/componentStyles/feedbackStyles/feedbackStyle.module.scss"; 
import { useNavigate, useSearchParams } from 'react-router-dom';
import { formatDateAccordingToTimezoneUsingMoment, formatDateTime, thousandSeparator } from '../../../utils/constants';
import { UserContext, UserContextPayload } from '../../../context/userContext';
import CampaignTemplatePreview from './campaignTemplatePreview';
import CampaignAnalysisPieChart from './campaignAnalysisPieChart';
import GlobalButton from '../../utility/globalButton/button';
import CampaignAnalysisContacts from './campaignAnalysisContacts';
import { campaignContactAssignmentData, createCampaignContactTagPayload, createCampaignResponse, tagDataInterface, tagDeleteConfirmation, updateCampaignContactTagPayload } from '../../../models/axiosModel';
import GlobalPopUp from '../../utility/globalPopUp';
import CampaignContactStatusTrack from './campaignContactStatusTrack';
import style from "../../../assets/styles/componentStyles/whatsappCampaignStyles/whatsappCampaignStyle.module.scss";
import globalStyles from './../../../assets/styles/global.module.scss'
import ContactTagActionPopup from './contactTagActionPopup';
import { ContactContext, ContactContextPayload } from '../../../context/contactContext';
import { flagAddTagDialogObj } from '../contacts/contactsGlobal';
import AddNewTagPopup from '../contacts/addNewTagPopup';
import agent from '../../../services/api';
import contactStyles from '../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss'
import { CAMPAIGN_STATUS, emptyCampaignObject, isCarouselTemplate } from './campaignConstant';
import Popper from '@mui/material/Popper';
import { getExecutionColor, isCampaignStatusCompleted } from './utils';
import CampaignCarouselTemplatePreview from './campaignCarouselTemplatePreview';
import moment, { Moment } from 'moment';
import { DateRangePicker, FocusedInputShape } from 'react-dates';
import DatePresets from '../callAnalysis/datePresets';
import CampaignListTable from './campaignListTable';
import GlobalDeletePopup from '../../utility/globalDeletePopup/globalDeletePopup';
import { hasQuickReplyBtn, hasVisitWebsiteBtnandTrackingEnabled } from '../channels/global/whatsapp/templates/utils';
import { useGenericStore } from '../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';
import useGenericHook from '../../../hooks/useGenericHook';
import RefreshIcon from '@mui/icons-material/Refresh';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { primaryColor } from '../../../utils/colors';
interface CampaignAnalysisProps {
    getCampaignDataApiCall: (campaign_id?: number) => void
    flagDashboardPage?: boolean;
}

interface filterCampaignAnalyticsData {
    startDate: Moment | null;
    endDate: Moment | null;
}


const CampaignAnalysis: React.FC<CampaignAnalysisProps> = (props: CampaignAnalysisProps) => {
    const { getCampaignDataApiCall, flagDashboardPage } = props;

    const { selectedWhatsAppCampaign, setSelectedWhatsAppCampaign, messageTemplateDetail, getWhatsappTemplateDetailsApiCall, whatsappCampaignListdData, campaignContactStatusPopup, setCampaignContactStatusPopup, getCampaignListApi, getMultipleCampaignDataApi } = useContext(WhatsappCampaignContext) as WhatsappCampaignContextPayload;
    const { flagLoading, setFlagLoading, userDetail, handleError } = useContext(UserContext) as UserContextPayload
    const { getListOfCampaignContactTagApi, deleteCampaignContactTagApi } = useContext(ContactContext) as ContactContextPayload

    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))

    const navigate = useNavigate();
    const smallScreen = useMediaQuery('(max-width : 900px) and (min-width : 0px)');
    const tabletScreen = useMediaQuery('(max-width : 900px) and (min-width : 600px)');
    const largeScreen = useMediaQuery('(min-width : 1850px)');
    const laptopScreen = useMediaQuery('(max-width : 1200px)');
    const largeLaptopScreen = useMediaQuery('(min-width : 1200px) and (max-width : 1450px)');
    const tabScreen = useMediaQuery("(max-width : 1000px) and (min-width : 0px)");

    const { isScreenBelow768 } = useGenericHook();

    const innerHeight = tabletScreen ? (window.innerHeight - 145) : (window.innerHeight - 130);
    const [searchParams, setSearchParams] = useSearchParams();
    const [contactTagData, setContactTagData] = useState<tagDataInterface[]>([])
    const campaign_id = searchParams.get('campaign_id')
    const campaignIdsParams = searchParams.get('campaignIds')
    const startDateParams = searchParams.get('start_date')
    const endDateParams = searchParams.get('end_date')

    const [campaignIds, setCampaignIds] = useState<number[]>([]);
    const [multipleCampaignsData, setMultipleCampaignsData] = useState<createCampaignResponse | null>(null);
    const [flagAnalyticsStatus, setFlagAnalyticsStatus] = useState<boolean>(false);

    const [filterCampaignAnalyticsData, setFilterCampaignAnalyticsData] = useState<filterCampaignAnalyticsData>({
        startDate: null,
        endDate: null
    }); 
    const [focusedDateRangePickerInput, setFocusedDateRangePickerInput] = useState<FocusedInputShape | null>(null);
    const dateFormat = "DD-MMM-YYYY"; 

    const [tagDeleteConfirmation, setTagDeleteConfirmation] = useState<tagDeleteConfirmation>({
        flagShowConfirmation: false,
        selectedTag: null,
    })

    async function getWhatsappCampaignList() {
        // setFlagLoading({ ...flagLoading, flagRoundLoader: true })
        await getCampaignListApi()
        // setFlagLoading({ ...flagLoading, flagRoundLoader: false })
    }
    useEffect(() => {
        if(!flagDashboardPage){
            getWhatsappCampaignList()
        }
    }, [])
    const CustomPopper = (props: any) => {
        return (
            <Popper
                {...props}
                disableScrollLock
                modifiers={[
                    {
                        name: 'flip',
                        enabled: false, // :point_left: DISABLE the flipping
                    },
                ]}
            />
        );
    };

    let initialData = {
        preSelectedContacts: [],
        postpopupSelectedContacts: [],
        tagsToAssign: [],
        tagsToRemove: [],
        flagOpenBulkAction: false,
        flagAssignTag: true,
        flagRemove: false,
    }
    const [filterByStatus, setFilterByStatus] = useState<string[] | []>([])
    const [contactTagActionData, setContactTagActionData] = useState(initialData)

    function   onChangeOfFilterStatus(actionType: string, value: any, flagAllContacts?: boolean, selectedContact?: any) {
        let contacts: any = contactTagActionData.preSelectedContacts
        switch (actionType) {
            case 'filterByStatus':
                const hasUndeliveredMessage = value.some(
                    (status: string) => status.toLowerCase() === 'message undelivered'
                );
                const campaignContacts = hasUndeliveredMessage
                ? selectedWhatsAppCampaign?.campaign_contact_assignment_data
                : selectedWhatsAppCampaign?.campaign_contact_assignment_data?.filter(
                    (contact) =>
                        contact?.campaign_execution_status_name?.toLowerCase() !==
                        'message undelivered'
                    );
                if (value.some((status: string) => status.toLowerCase() == 'failed')) {
                    if (value.some((status: string) => status.toLowerCase() == 'clicked' || status.toLowerCase() == 'replied')) {
                        let finalContacts = campaignContacts
                            ?.filter((contact) =>
                                contact?.campaign_execution_tracking_data?.some((entry: any) =>
                                    entry?.message_status &&
                                    value.map((v: string) => v.toLowerCase()).includes(entry.message_status.toLowerCase())
                                )
                            )
                            .filter((contact: any) => !contact.flag_deleted);

                        let analyticsContacts = selectedWhatsAppCampaign?.campaign_contact_assignment_data
                            ?.filter((contact) =>
                                contact?.campaign_analytics_status?.some((entry: any) =>
                                    entry?.campaign_execution_status_name &&
                                    value.map((v: string) => v.toLowerCase()).includes(entry.campaign_execution_status_name.toLowerCase())
                                )
                            )?.filter((contact: any) => !contact.flag_deleted)

                        if (analyticsContacts && analyticsContacts?.length > 0) {
                            analyticsContacts?.map((analytics) => {
                                if (!finalContacts?.find((final) => final.campaign_contact_assignment_id == analytics.campaign_contact_assignment_id)) {
                                    finalContacts?.push(analytics)
                                }
                            })
                        }

                        contacts = finalContacts
                    }

                    else {
                        contacts = campaignContacts
                            ?.filter((contact) =>
                                contact?.campaign_execution_tracking_data?.some((entry: any) =>
                                    entry?.message_status &&
                                    value.map((v: string) => v.toLowerCase()).includes(entry.message_status.toLowerCase())
                                )
                            )
                            .filter((contact: any) => !contact.flag_deleted);
                    }

                }
                else {
                    let finalContacts = campaignContacts
                        ?.filter((contact) =>{
                            const statusExistInTrackingData = contact?.campaign_execution_tracking_data?.some((entry: any) =>
                                entry?.message_status &&
                                value.map((v: string) => v.toLowerCase()).includes(entry.message_status.toLowerCase())
                            )
                            const statusExist = value?.map((v: string) => v?.toLowerCase())?.includes(contact?.campaign_execution_tracking_status?.toLowerCase());

                            return statusExistInTrackingData || statusExist;
                        })?.filter((contact: any) => !contact.flag_deleted && contact.campaign_execution_tracking_status.toLowerCase() != 'failed')

                    let analyticsContacts = selectedWhatsAppCampaign?.campaign_contact_assignment_data
                        ?.filter((contact) =>
                            contact?.campaign_analytics_status?.some((entry: any) =>
                                entry?.campaign_execution_status_name &&
                                value.map((v: string) => v.toLowerCase()).includes(entry.campaign_execution_status_name.toLowerCase())
                            )
                        )?.filter((contact: any) => !contact.flag_deleted && contact.campaign_execution_tracking_status.toLowerCase() != 'failed')

                    if (analyticsContacts && analyticsContacts?.length > 0) {
                        analyticsContacts?.map((analytics) => {
                            if (!finalContacts?.find((final) => final.campaign_contact_assignment_id == analytics.campaign_contact_assignment_id)) {
                                finalContacts?.push(analytics)
                            }
                        })
                    }

                    contacts = finalContacts
                }
                break;
            case 'manualEdit':
                if (flagAllContacts) {
                    if (value) {
                        contacts = selectedWhatsAppCampaign?.campaign_contact_assignment_data.filter((contact: any) => !contact.flag_deleted)
                    } else {
                        contacts = []
                    }
                } else {
                    if (value) {
                        contacts.push(selectedContact)
                    } else {
                        contacts = contacts.filter((contact: any) => contact.contact_id !== selectedContact.contact_id)
                    }
                }

        }
        setContactTagActionData((prevState: any) => ({
            ...prevState,
            preSelectedContacts: contacts
        }))
    }
    function onChangeContactTagActionData(key: string, value: any) {
        setContactTagActionData((prevState: any) => ({
            ...prevState,
            [key]: value
        }))
    }

    async function handleSaveAction() {
        try {
            setFlagLoading({ ...flagLoading, flagRoundLoader: true });
            const selectedContactIds = contactTagActionData.preSelectedContacts.map((contact: any) => contact.contact_id);
            let payload: any = {
                contact_list_id: selectedWhatsAppCampaign?.contact_list_id,
                contact_id: selectedContactIds,
                flag_delete_contact: false
            }

            if (contactTagActionData.flagAssignTag) {
                if (contactTagActionData.flagRemove) {
                    payload = {
                        ...payload,
                        remove_contact_tag_id: contactTagActionData.tagsToAssign.map((tag: any) => tag.contact_tag_id),
                    }
                } else {
                    payload = {
                        ...payload,
                        add_contact_tag_id: contactTagActionData.tagsToAssign.map((tag: any) => tag.contact_tag_id),
                    }
                }
            } else { // this is for deleting contacts
                payload = {
                    ...payload,
                    flag_delete_contact: true,
                }
            }

            const response = await agent.contactTagActions.put(payload);
            if (response.status) {
                let successMessage = contactTagActionData.flagAssignTag
                    ? contactTagActionData.flagRemove
                        ? "Tags Removed Successfully"
                        : "Tags Assigned Successfully"
                    : "Contacts Deleted Successfully";

                showSuccess(successMessage)

                setContactTagActionData(initialData);
                setFilterByStatus([]);
            } else {
                handleError(response);
            }
        } catch (error) {
            handleError(error);
        } finally {
            setFlagLoading({ ...flagLoading, flagRoundLoader: false });
        }
    }

    const getListOfCampaignContactTagApiCall = async (contact_list_id: number) => {
        const res = await getListOfCampaignContactTagApi(contact_list_id);
        if(res.status){
            setContactTagData(res?.data?.[0]?.contact_tag_data);
        } else {
            handleError(res);
        }
    }

    useEffect(() => {
        if (selectedWhatsAppCampaign && !flagDashboardPage) {
            (async () => {
                setFlagLoading({ ...flagLoading, flagRoundLoader: true })
                const res = await getWhatsappTemplateDetailsApiCall(selectedWhatsAppCampaign.meta_integration_whatsapp_id, selectedWhatsAppCampaign.whatsapp_template_id)
                getListOfCampaignContactTagApiCall(selectedWhatsAppCampaign.contact_list_id);
                if (!(res.status)) {
                    handleError(res);
                }
                setFlagLoading({ ...flagLoading, flagRoundLoader: false })
            })()
        }
    }, [selectedWhatsAppCampaign])

    const handleBackCurrentCampaign = async () => {
        setSelectedWhatsAppCampaign(null)
        navigate(`${window.location.pathname}`)
    }


    const roundOffData = (numData: number, denData: number, flagCard?: boolean) => {
        const percentage = (numData / (denData == 0 ? 1 : denData)) * 100;
        const formattedPercentage = percentage % 1 === 0 ? `${percentage}%` : flagCard ? `${percentage.toFixed(1)}%` : `${percentage.toFixed(2)}%`;

        return formattedPercentage;
    }

    const AnalysisCardData = [
        {
            cardTitle: "Total Contact",
            cardValue: flagDashboardPage ? multipleCampaignsData?.total_campaign_contact || 0 : selectedWhatsAppCampaign?.total_campaign_contact || 0,
            boxShadow: "0px 0px 2px rgba(106, 9, 125, 1)",
            progressValue: null
        },
        {
            cardTitle: "Sent Successfully",
            cardValue: flagDashboardPage ? multipleCampaignsData?.total_sent_campaign_contact || 0 : selectedWhatsAppCampaign?.total_sent_campaign_contact || 0,
            boxShadow: "0px 0px 2px rgba(0, 208, 62, 1)",
            progressValue: ""
        },
        {
            cardTitle: "Pending",
            cardValue: flagDashboardPage ? multipleCampaignsData?.total_pending_campaign_contact || 0 : selectedWhatsAppCampaign?.total_pending_campaign_contact || 0,
            boxShadow: "0px 0px 2px rgba(205, 188, 0, 1)",
            progressValue: ""
        },
        {
            cardTitle: "Failed",
            cardValue: flagDashboardPage ? multipleCampaignsData?.total_failed_campaign_contact || 0 : selectedWhatsAppCampaign?.total_failed_campaign_contact || 0,
            boxShadow: "0px 0px 2px rgba(223, 0, 0, 1)",
            progressValue: ""
        },
        {
            cardTitle: "Undelivered",
            cardValue: flagDashboardPage ? multipleCampaignsData?.total_message_undelivered_campaign_contact || 0 : selectedWhatsAppCampaign?.total_message_undelivered_campaign_contact || 0,
            boxShadow: "0px 0px 2px rgba(255, 152, 0, 1)",
            progressValue: ""
        },
        {
            cardTitle: "Delivered",
            cardValue: flagDashboardPage ? multipleCampaignsData?.total_delivered_campaign_contact || 0 : selectedWhatsAppCampaign?.total_delivered_campaign_contact || 0,
            boxShadow: "0px 0px 2px rgba(128, 128, 128, 1)",
            progressValue: ""
        },
        {
            cardTitle: "Read",
            cardValue: flagDashboardPage ? multipleCampaignsData?.total_read_campaign_contact || 0 : selectedWhatsAppCampaign?.total_read_campaign_contact || 0,
            boxShadow: "0px 0px 2px rgba(79, 182, 236, 1)",
            progressValue: ""
        },
        // {
        //     cardTitle: "Unread",
        //     cardValue: flagDashboardPage ? ((multipleCampaignsData ? multipleCampaignsData?.total_delivered_campaign_contact : 0) - (multipleCampaignsData ? multipleCampaignsData?.total_read_campaign_contact : 0)) || 0 : ((selectedWhatsAppCampaign ? selectedWhatsAppCampaign.total_delivered_campaign_contact : 0) - (selectedWhatsAppCampaign ? selectedWhatsAppCampaign.total_read_campaign_contact : 0)) || 0,
        //     boxShadow: "0px 0px 2px rgba(19, 79, 92, 1)",
        //     progressValue: ""
        // },
        // {
        //     cardTitle: "Clicked",
        //     cardValue: flagDashboardPage ? multipleCampaignsData?.total_contacts_who_clicked || 0 : selectedWhatsAppCampaign?.total_contacts_who_clicked || 0,
        //     boxShadow: "0px 0px 2px rgba(120, 0, 16, 1)",
        //     progressValue: ""
        // },
        // {
        //     cardTitle: "Replied",
        //     cardValue: flagDashboardPage ? multipleCampaignsData?.total_contacts_who_replied || 0 : selectedWhatsAppCampaign?.total_contacts_who_replied || 0,
        //     boxShadow: "0px 0px 2px rgba(19, 79, 92, 1)",
        //     progressValue: ""
        // },
    ]

    if(flagDashboardPage || hasVisitWebsiteBtnandTrackingEnabled(messageTemplateDetail)){
        AnalysisCardData.push({
            cardTitle: "Clicked",
            cardValue: flagDashboardPage ? multipleCampaignsData?.total_contacts_who_clicked || 0 : selectedWhatsAppCampaign?.total_contacts_who_clicked || 0,
            boxShadow: "0px 0px 2px rgba(120, 0, 16, 1)",
            progressValue: "",
        })
    }
    if(flagDashboardPage || hasQuickReplyBtn(messageTemplateDetail)){
        AnalysisCardData.push({
            cardTitle: "Replied",
            cardValue: flagDashboardPage ? multipleCampaignsData?.total_contacts_who_replied || 0 : selectedWhatsAppCampaign?.total_contacts_who_replied || 0,
            boxShadow: "0px 0px 2px rgba(19, 79, 92, 1)",
            progressValue: "",
        })
    }

    const cardHoverText = (cardTitle: string) => {
        if(cardTitle?.toLowerCase() === "clicked"){
            return "Total contacts that interacted with the “Visit Website” button.";
        } else if(cardTitle?.toLowerCase() === "replied"){
            return "Total contacts that interacted with the “Quick Reply” button.";
        }
        return "";
    }

    const campaignDetailsData = [
        {
            detailsKey: "Campaign Name",
            detailsValue: selectedWhatsAppCampaign?.campaign_title
        },
        {
            detailsKey: "Created At",
            detailsValue: formatDateAccordingToTimezoneUsingMoment(selectedWhatsAppCampaign?.created_at_timestamp, userDetail.timezone_hour)
        },
        {
            detailsKey: "Updated At",
            detailsValue: selectedWhatsAppCampaign?.updated_at_timestamp ? formatDateAccordingToTimezoneUsingMoment(selectedWhatsAppCampaign?.updated_at_timestamp, userDetail.timezone_hour) : "-"
        }
    ]

    const templateName = selectedWhatsAppCampaign?.whatsapp_template_display_name ?? selectedWhatsAppCampaign?.whatsapp_template_name;

    const templateDetailsData = [
        {
            templateDetailsKey: "WABA ID",
            templateDetailsValue: selectedWhatsAppCampaign?.waba_id
        },
        {
            templateDetailsKey: "WABA Name",
            templateDetailsValue: selectedWhatsAppCampaign?.waba_name
        },
        {
            templateDetailsKey: "Phone Number",
            templateDetailsValue: selectedWhatsAppCampaign?.display_phone_number
        },
        {
            templateDetailsKey: "Template Name",
            templateDetailsValue: (selectedWhatsAppCampaign?.meta_integration_whatsapp_id && selectedWhatsAppCampaign?.whatsapp_template_id) ?
                <a
                    className={style.templateRedirectURL}
                    href={`/channels/viewintegration/whatsapp/templatelibrary/modifyTemplate?id=${selectedWhatsAppCampaign?.meta_integration_whatsapp_id}&template_id=${selectedWhatsAppCampaign?.whatsapp_template_id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {templateName}
                </a>
                :
                templateName
        },
        {
            templateDetailsKey: "Template",
            templateDetailsValue: messageTemplateDetail ? isCarouselTemplate(messageTemplateDetail) ? <CampaignCarouselTemplatePreview metaInformation={messageTemplateDetail} /> : <CampaignTemplatePreview metaInformation={messageTemplateDetail} /> : <></>
        }
    ]

    const cardDetailsColor = (executionStatus?: string, flagLightColor?: boolean) => {
        if (executionStatus) {
            let executionStatusName = executionStatus.toLowerCase();
            switch (executionStatusName) {
                case "sent":
                    return flagLightColor ? "rgba(208, 89, 4, 0.1)" : "rgba(208, 89, 4, 1)"
                case "pending":
                    return flagLightColor ? "rgba(222, 204, 2, 0.1)" : "rgba(222, 204, 2, 1)"
                case "failed":
                    return flagLightColor ? "rgba(223, 0, 0, 0.1)" : "rgba(223, 0, 0, 1)"
                case "undelivered":
                case "message undelivered":
                    return flagLightColor ? "rgba(255, 152, 0, 0.1)" : "rgba(255, 152, 0, 1)"
                case "total contact":
                    return flagLightColor ? "rgba(106, 9, 125, 0.1)" : "rgba(106, 9, 125, 1)"
                case "read":
                    return flagLightColor ? "rgba(79, 182, 236, 0.1)" : "rgba(79, 182, 236, 1)"
                case "delivered":
                    return flagLightColor ? "rgba(128, 128, 128, 0.1)" : "rgba(128, 128, 128, 1)"
                case "unread":
                    return flagLightColor ? "rgba(19, 79, 92, 0.1)" : "rgba(19, 79, 92, 1)"
                case "clicked":
                    return flagLightColor ? "rgba(120, 0, 16, 0.1)" : "rgba(120, 0, 16, 1)"
                case "replied":
                    return flagLightColor ? "rgba(19, 79, 92, 0.1)" : "rgba(19, 79, 92, 1)"
                default:
                    return flagLightColor ? "rgba(0, 208, 62, 0.1)" : "rgba(0, 208, 62, 1)"
            }
        }
    }
    const [flagAddTagDialogObj, setFlagAddTagDialogObj] = useState<flagAddTagDialogObj>({
        flag: false,
        flagFromEditContactDialog: false,
    })
    const handleCloseTagDialog = () => {
        if (flagAddTagDialogObj.flagFromEditContactDialog) {
            setFlagEditContactDialog(true);
        }
        setFlagAddTagDialogObj((prev) => ({
            flag: false,
            flagFromEditContactDialog: false,
        }));
    }

    function setFlagEditContactDialog(value: any) {
        setFlagAddTagDialogObj((prevState) => ({ ...prevState, flag: value }))
    }

    const getValueOfSelectCampaigns = () => {
        if (whatsappCampaignListdData) {
            const filteredcampaign = whatsappCampaignListdData?.filter((campaign: createCampaignResponse) => campaignIds.includes(campaign.campaign_id));
            if (filteredcampaign.length > 0) {
                return filteredcampaign;
            } else return [emptyCampaignObject];
        } else {
            return [];
        }
    }

    const onChangeOfCampaign = (value: createCampaignResponse[]) => {
        const isAllCampaignSelected = value.some(campaign => campaign.campaign_id == -1);
        const isOnlyAllCampaignSelected = value.length == 1 && isAllCampaignSelected;

        let selectedIds: number[] = [];

        if (isAllCampaignSelected && !isOnlyAllCampaignSelected) {
            if (campaignIds.includes(-1)) {
                selectedIds = value.filter(campaign => campaign.campaign_id != -1).map(campaign => campaign.campaign_id);
            } else {
                selectedIds = [-1];
            }
        } else if (isOnlyAllCampaignSelected || value.length === 0) {
            selectedIds = [-1];
        } else {
            selectedIds = value.map(campaign => campaign.campaign_id);
        }

        setCampaignIds(selectedIds);

    }

    const formatDate = (dateString: Moment | null) => {
        return dateString ? formatDateTime(dateString, "ymd") : null
    };

    const handleFetchClick = () => {
        // const params = new URLSearchParams(searchParams.toString());
        // if (campaignIds.length == 1 && campaignIds[0] == -1) {
        //     params.delete('campaignIds');
        // } else {
        //     params.set('campaignIds', campaignIds.toString());
        // }
        // setSearchParams(params);
        let params = Object.fromEntries(searchParams.entries());
        const { startDate, endDate: selectedEndDate } = filterCampaignAnalyticsData;
        const endDate = startDate && !selectedEndDate ? moment() : selectedEndDate;

        if(!startDate && !endDate){
            delete params.start_date;
            delete params.end_date;
            setSearchParams(params);
        } else {
            if (params.start_date != formatDate(startDate) || params.end_date != formatDate(endDate)) {
                if(startDate){
                    params.start_date = formatDate(startDate) || "";
                }
                if(endDate){
                    params.end_date = formatDate(endDate) || "";
                }
                setSearchParams(params);
            }
        }
    }

    const checkDisableFetchBtn = () => {
        if(!filterCampaignAnalyticsData?.startDate || !filterCampaignAnalyticsData?.endDate){
            return true;
        }
        return false;
    }

    const getMultipleCampaignDataApiCall = async (campaign_ids: string | null, startDateParams: string | null, endDateParams: string | null) => {
        setFlagLoading(prevState => ({ ...prevState, flagRoundLoader: true }));
        const res = await getMultipleCampaignDataApi(campaign_ids, startDateParams, endDateParams);
        if (!(res.status)) {
            handleError(res);
        } else {
            setMultipleCampaignsData(res.data?.[0]);
        }
        setFlagLoading(prevState => ({ ...prevState, flagRoundLoader: false }));
    }

    useEffect(() => {
        if (flagDashboardPage) {
            getMultipleCampaignDataApiCall(campaignIdsParams, startDateParams, endDateParams);
            
            const { startDate, endDate} = filterCampaignAnalyticsData;
            let updatedStartDate: Moment | null = startDate;
            let updatedEndDate: Moment | null = endDate;

            if(startDateParams != formatDate(startDate)) updatedStartDate = startDateParams ? moment(startDateParams, 'YYYY-MM-DD') : null;
            if(endDateParams != formatDate(endDate)) updatedEndDate = endDateParams ? moment(endDateParams, 'YYYY-MM-DD') : null;

            setFilterCampaignAnalyticsData((prev) => ({
                ...prev,
                startDate: updatedStartDate,
                endDate: updatedEndDate
            }))
        }
    }, [campaignIdsParams, startDateParams, endDateParams])

    useEffect(() => {
        if (whatsappCampaignListdData && whatsappCampaignListdData.length > 0 && flagDashboardPage) {
            if (campaignIdsParams) {
                setCampaignIds(campaignIdsParams.split(",").map(Number));
            } else {
                setCampaignIds([-1]);
            }
        }
    }, [whatsappCampaignListdData])

    const onClickOfDeleteTag = (tag: tagDataInterface) => {
        setTagDeleteConfirmation((prev) => ({
            ...prev,
            flagShowConfirmation: true,
            selectedTag: tag,
        }))
    }

    const onCloseOfDeleteTagPopup = () => {
        setTagDeleteConfirmation((prev) => ({
            ...prev,
            flagShowConfirmation: false,
            selectedTag: null,
        }))
    }

    const deleteContactTagApiCall = async () => {
        const contactTagId = tagDeleteConfirmation?.selectedTag?.contact_tag_id;
        if(contactTagId){
            setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
            const res = await deleteCampaignContactTagApi(contactTagId);
            if(!(res.status)){
                handleError(res);
            } else {
                const contactListId = selectedWhatsAppCampaign?.contact_list_id;
                if (contactListId) getListOfCampaignContactTagApiCall(contactListId);
            }
            setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
        }
        onCloseOfDeleteTagPopup();
    }

    const filterStatusOptions = useMemo(() => {
        const filterOptions = ['Read', 'Delivered', 'Sent', 'Failed', 'Clicked', 'Replied', 'Message Undelivered'];
        return filterOptions;
    }, [selectedWhatsAppCampaign?.campaign_execution_status_name])

    const renderCard = (cards: any, ind: number) => {
        return (
            <Grid item key={ind} className={styles.commonCardStyles} sx={{ boxShadow: cards?.boxShadow ?? "", ':hover': { backgroundColor: `${cardDetailsColor(cards?.cardTitle, true)} !important` } }}>
                <Grid container direction={isScreenBelow768 ? "row" : "column"} gap={"12px"} justifyContent={isScreenBelow768 ? "space-between" : "flex-start"} alignItems={isScreenBelow768 ? "center" : "flex-start"}>
                    <Grid item>
                        <span className={styles.cardHeadingTextStyle}>{cards?.cardTitle}</span>
                    </Grid>
                    <Grid item>
                        <Grid container justifyContent={isScreenBelow768 ? "center" : "flex-start"} gap={1} alignItems={isScreenBelow768 ? "center" : "flex-start"} >
                            <span className={styles.cardValueTextStyle}>{thousandSeparator(cards?.cardValue)}</span>
                            {cards?.progressValue !== null &&
                                <Tooltip placement='top' title={cards?.cardTitle?.toLowerCase() === "undelivered" ? '' : cards?.cardTitle?.toLowerCase() === "delivered" ? "% Compared with total sent contacts" : "% Compared with total delivered contacts"}>
                                    <Grid item className={circularStyle.circularProgress}>
                                        <Avatar className={circularStyle.avatarStyles} sx={{ color: cardDetailsColor(cards?.cardTitle), border: `3px solid ${cardDetailsColor(cards?.cardTitle)}` }}>
                                            {cards?.cardTitle?.toLowerCase() === "undelivered" ? 
                                                roundOffData(cards?.cardValue || 0, flagDashboardPage ? multipleCampaignsData?.total_campaign_contact || 0 : selectedWhatsAppCampaign?.total_campaign_contact || 0, true)
                                                :
                                                roundOffData(cards?.cardValue || 0, cards?.cardTitle?.toLowerCase() === "delivered" ? flagDashboardPage ? multipleCampaignsData?.total_sent_campaign_contact || 0 : selectedWhatsAppCampaign?.total_sent_campaign_contact || 0 : flagDashboardPage ? multipleCampaignsData?.total_delivered_campaign_contact || 0 : selectedWhatsAppCampaign?.total_delivered_campaign_contact || 0, true)
                                            }
                                        </Avatar>
                                    </Grid>
                                </Tooltip>
                            }
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        )
    }

    const getCampaignListOptions = () => {
        if(whatsappCampaignListdData){
            const excludedCampaignStatuses = [
                CAMPAIGN_STATUS["DRAFT"].toLowerCase(),
                CAMPAIGN_STATUS["SCHEDULED"].toLowerCase()
            ]
            return whatsappCampaignListdData?.filter((campaign) => !excludedCampaignStatuses.includes(campaign?.campaign_execution_status_name?.toLowerCase())) || [];
        }
        return [];
    }

    return (
        <>
            {(selectedWhatsAppCampaign || flagDashboardPage) &&
                <Grid container direction={"column"} flexWrap={"nowrap"} gap={2} sx={{ height: `${innerHeight}px !important`, maxHeight: `${innerHeight}px !important`, overflow: "auto", padding: "1px 5px" }}>
                    <Grid item sx={{ width: "100%" }}>
                        <Grid container gap={"12px"} alignItems={"center"} justifyContent={flagDashboardPage ? "end" : smallScreen ? "start" : "space-between"}>
                            <Grid item>
                                <Grid container gap={"12px"} alignItems={"center"} flexWrap={"wrap"}>
                                    {!flagDashboardPage &&
                                        <Grid item className={globalStyles.displayFlexStyle} mt={"1px"}>
                                            <KeyboardBackspaceIcon 
                                                onClick={() => handleBackCurrentCampaign()} 
                                                className={`${globalStyles.clickable} ${globalStyles.primaryColor}`}
                                            />
                                        </Grid>
                                    }
                                    <Grid item>
                                        {flagDashboardPage ?
                                             <Grid item className={`${datePickerStyles.dateRangePickerClass} ${feedbackStyles.dateRangePickerClass} ${styles.dateRangePickerClass}`} >
                                                <DateRangePicker
                                                    startDate={filterCampaignAnalyticsData.startDate}
                                                    startDateId='s_id'
                                                    endDate={filterCampaignAnalyticsData.endDate}
                                                    endDateId='e_id'
                                                    readOnly
                                                    onDatesChange={({ startDate, endDate }) => {
                                                        if (startDate != filterCampaignAnalyticsData.startDate) {
                                                            endDate = null;
                                                        }
                                                        setFilterCampaignAnalyticsData((prev) => ({
                                                            ...prev,
                                                            startDate: startDate,
                                                            endDate: endDate,
                                                        }))
                                                    }}
                                                    focusedInput={focusedDateRangePickerInput}
                                                    displayFormat={dateFormat}
                                                    numberOfMonths={tabScreen ? 1 : 2}
                                                    minimumNights={0}
                                                    onFocusChange={(focusedDateRangePickerInput) => setFocusedDateRangePickerInput(focusedDateRangePickerInput)}
                                                    isOutsideRange={(day) => day.isAfter(moment().endOf("day"))}
                                                    onClose={({ startDate, endDate }) => {
                                                        if (startDate && !endDate) {
                                                            setFilterCampaignAnalyticsData((prev) => ({
                                                                ...prev,
                                                                endDate: moment(),
                                                            }));
                                                        }
                                                    }}
                                                    renderCalendarInfo={() => (
                                                        <DatePresets
                                                            startDate={filterCampaignAnalyticsData.startDate}
                                                            endDate={filterCampaignAnalyticsData.endDate}
                                                            dateFormat={dateFormat}
                                                            handlePresets={(start: Moment, end: Moment) => {
                                                                setFilterCampaignAnalyticsData((prev) => ({
                                                                    ...prev,
                                                                    startDate: start,
                                                                    endDate: end,
                                                                }))
                                                                setFocusedDateRangePickerInput(null);
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                            :
                                            <Autocomplete
                                                className={`${style.whatsappCampaignDropDowns} ${style.whatsappCampaignListDropDown}`}
                                                disableClearable
                                                options={getCampaignListOptions()}
                                                value={selectedWhatsAppCampaign || undefined}
                                                ListboxProps={{
                                                    className: style.autocompleteListbox,
                                                }}
                                                isOptionEqualToValue={(option, value) => option.campaign_id == value.campaign_id}
                                                getOptionLabel={(option) => option?.campaign_title || ""}
                                                onChange={(e, value) => { navigate(`${window.location.pathname}?campaign_id=${value?.campaign_id}`) }}
                                                renderInput={(params) => <TextField {...params} placeholder="Select Campaign" />}
                                            />
                                        }
                                    </Grid>
                                    {/* <Grid item>
                                <span className={styles.campaignNameStyles}>{selectedWhatsAppCampaign?.campaign_title}</span>
                            </Grid> */}
                                    {flagDashboardPage ?
                                        <Grid item>
                                            <GlobalButton
                                                buttonText="Fetch"
                                                className="primaryButtonStyle"
                                                sx={{ width: "100px !important" }}
                                                onClick={() => handleFetchClick()}
                                                disabled={checkDisableFetchBtn()}
                                            />
                                        </Grid>
                                        :
                                        <>
                                            <Grid item mt={"4px"} className={`${styles.campaignStatusStyle} ${globalStyles.displayFlex}`} sx={{ boxShadow: `0px 0px 2px ${getExecutionColor(selectedWhatsAppCampaign?.campaign_execution_status_name)}`, backgroundColor: getExecutionColor(selectedWhatsAppCampaign?.campaign_execution_status_name, true) }}>
                                                <span className={styles.campaignStatusTextStyle} style={{ color: getExecutionColor(selectedWhatsAppCampaign?.campaign_execution_status_name) }}>{selectedWhatsAppCampaign?.campaign_execution_status_name}</span>
                                            </Grid>
                                            <Grid item>
                                                <Grid container gap={"12px"} alignItems={"center"} flexWrap={"nowrap"}>
                                                    <Grid item>
                                                        <GlobalButton
                                                            buttonText={isScreenBelow768 ? "Refresh" : "Refresh Data"}
                                                            className="primaryButtonStyle"
                                                            startIcon={isScreenBelow768 ? <RefreshIcon /> : undefined}
                                                            onClick={() => getCampaignDataApiCall(Number(campaign_id))}
                                                        />
                                                    </Grid>
                                                    {smallScreen &&
                                                        <Grid item>
                                                            <GlobalButton 
                                                                className="primaryButtonStyle" 
                                                                buttonText="View" 
                                                                sx={{ width: "100px !important" }} 
                                                                onClick={() => { navigate(`/whatsappcampaign/createnewcampaign?campaign_id=${campaign_id}`); setSelectedWhatsAppCampaign(null); }} 
                                                                startIcon={isScreenBelow768 ? <RemoveRedEyeIcon /> : undefined}
                                                            />
                                                        </Grid>
                                                    }
                                                </Grid>
                                            </Grid>
                                        </>
                                    }
                                </Grid>
                            </Grid>
                            {!flagDashboardPage && !smallScreen &&
                                <Grid item>
                                    <GlobalButton className="primaryButtonStyle" buttonText="View Campaign Details" sx={{ width: "200px !important" }} onClick={() => { navigate(`/whatsappcampaign/createnewcampaign?campaign_id=${campaign_id}`); setSelectedWhatsAppCampaign(null); }} />
                                </Grid>
                            }
                        </Grid>
                    </Grid>

                    <Grid item sx={{ width: "100%" }}>
                        <Grid container gap={(largeScreen && !flagDashboardPage) ? 0 : 1}>
                            <Grid item xs={(largeScreen && !flagDashboardPage) ? 10 : 12}>
                                <Grid container gap={2}>
                                    <Grid item className={styles.cardComponentSectionStyle}>
                                        <Grid container gap={2} alignItems={"center"}>
                                            {AnalysisCardData.slice(0, AnalysisCardData?.length > 8 ? 5 : 4).map((cards, ind) =>
                                                <Grid key={ind} item className={styles.commonCardStyles} sx={{ boxShadow: cards?.boxShadow ?? "", ':hover': { backgroundColor: `${cardDetailsColor(cards?.cardTitle, true)} !important` } }}>
                                                    <Grid container direction={isScreenBelow768 ? "row" : "column"} gap={"12px"} justifyContent={isScreenBelow768 ? "space-between" : "flex-start"} alignItems={isScreenBelow768 ? "center" : "flex-start"}>
                                                        <Grid item>
                                                            <span className={styles.cardHeadingTextStyle}>{cards.cardTitle}</span>
                                                        </Grid>
                                                        <Grid item>
                                                            <Grid container justifyContent={isScreenBelow768 ? "center" : "flex-start"} gap={1} alignItems={isScreenBelow768 ? "center" : "flex-start"} >
                                                                <span className={styles.cardValueTextStyle}>{thousandSeparator(cards.cardValue)}</span>
                                                                {cards.progressValue !== null &&
                                                                    <Grid item className={circularStyle.circularProgress}>
                                                                        <Avatar className={circularStyle.avatarStyles} sx={{ color: cardDetailsColor(cards.cardTitle), border: `3px solid ${cardDetailsColor(cards.cardTitle)}` }}>
                                                                            {roundOffData(cards.cardValue || 0, flagDashboardPage ? multipleCampaignsData?.total_campaign_contact || 0 : selectedWhatsAppCampaign?.total_campaign_contact || 0, true)}
                                                                        </Avatar>
                                                                    </Grid>
                                                                }
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            )}
                                        </Grid>
                                    </Grid>
                                    <Grid item className={styles.cardComponentSectionStyle}>
                                        <Grid container gap={2} alignItems={"center"}>
                                            {AnalysisCardData.slice(AnalysisCardData?.length > 8 ? 5 : 4, AnalysisCardData?.length).map((cards, ind) =>
                                                <>
                                                    {(cards?.cardTitle?.toLowerCase() === "clicked" || cards?.cardTitle?.toLowerCase() === "replied") 
                                                    ? (
                                                        <Tooltip title={cardHoverText(cards?.cardTitle)} placement='bottom' arrow>
                                                            {renderCard(cards, ind)}
                                                        </Tooltip>
                                                    ) : (
                                                        renderCard(cards, ind)
                                                    )}
                                                </>
                                            )}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>

                            {flagDashboardPage && multipleCampaignsData &&
                                <Grid item xs={largeScreen ? 4.9 : laptopScreen ? 12 : largeLaptopScreen ? 8 : 6} className={globalStyles.fullwidth}>
                                    <CampaignAnalysisPieChart fieldName={"Campaign Status"} fieldData={multipleCampaignsData} roundOffData={roundOffData} flagDashboardPage={flagDashboardPage} />
                                </Grid>
                            }
                        </Grid>
                    </Grid>

                    {(!flagDashboardPage && selectedWhatsAppCampaign) &&
                        <Grid item sx={{ width: "100%" }} mt={1}>
                            <Grid container gap={2} flexWrap={{ xs: "wrap", lg: "nowrap" }}>
                                <Grid item className={styles.campaginDetailsContainer} sx={{ width: "100%" }} paddingRight={{ lg: "16px" }}>
                                    <Grid container direction={"column"} gap={2}>
                                        <Grid item sx={{ width: "100%" }}>
                                            <Grid container direction={"column"} gap={2}>
                                                <Grid item sx={{ width: "100%" }}>
                                                    <span className={styles.headingDetailsStyle}>Campaign Details</span>
                                                </Grid>
                                                <Grid item sx={{ width: "100%" }}>
                                                    <Grid container direction={"column"} className={styles.campaignDetailStyle}>
                                                        {campaignDetailsData.map((details, ind) =>
                                                            <Grid item key={ind} className={styles.detailsGridStyle} sx={{ width: "100%" }}>
                                                                <Grid container flexWrap={"nowrap"}>
                                                                    <Grid item xs={5.5} className={styles.detailsKeyContainer} sx={{ width: "100%" }}>
                                                                        <span className={styles.detailsKeyTextStyle}>{details.detailsKey}</span>
                                                                    </Grid>
                                                                    <Grid item xs={12} className={styles.detailsValueContainer} sx={{ width: "100%" }}>
                                                                        <span className={styles.detailsKeyTextStyle}>{details.detailsValue}</span>
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        )}
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item sx={{ width: "100%" }}>
                                            <CampaignAnalysisPieChart fieldName={"Campaign Status"} fieldData={selectedWhatsAppCampaign} roundOffData={roundOffData} />
                                        </Grid>
                                        {selectedWhatsAppCampaign?.total_clicked_count > 0 &&
                                            <Grid item sx={{ width: "100%" }}>
                                                <CampaignAnalysisPieChart fieldName={"Tracking Status"} fieldData={selectedWhatsAppCampaign} roundOffData={roundOffData} />
                                            </Grid>
                                        }
                                    </Grid>
                                </Grid>
                                <Grid item sx={{ width: "100%" }}>
                                    <Grid container direction={"column"} gap={2}>
                                        <Grid item sx={{ width: "100%" }}>
                                            <Grid container direction={"column"} gap={2}>
                                                <Grid item sx={{ width: "100%" }}>
                                                    <span className={styles.headingDetailsStyle}>Template Details</span>
                                                </Grid>
                                                <Grid item sx={{ width: "100%" }}>
                                                    <Grid container direction={"column"} className={styles.campaignDetailStyle}>
                                                        {templateDetailsData.map((details, index) =>
                                                            <Grid item key={index} className={styles.detailsGridStyle} sx={{ width: "100%" }}>
                                                                <Grid container flexWrap={"nowrap"} direction={{ xs: index == templateDetailsData.length - 1 ? "column" : "row", md: "row" }}>
                                                                    <Grid item xs={5.5} className={styles.detailsKeyContainer} sx={{ width: "100%" }}>
                                                                        <span className={styles.detailsKeyTextStyle}>{details.templateDetailsKey}</span>
                                                                    </Grid>
                                                                    <Grid item xs={12} className={styles.detailsValueContainer} sx={{ width: "100%" }}>
                                                                        <span className={styles.detailsKeyTextStyle}>{details.templateDetailsValue}</span>
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        )}
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    }

                    <Grid item sx={{ width: "100%" }} mt={1}>
                        <Grid container gap={2} xs={12} lg={12} paddingRight={"10px"}>
                            {(!flagDashboardPage && selectedWhatsAppCampaign) &&
                                <Grid item className={globalStyles.fullwidth}>
                                    <Grid container justifyContent={"space-between"}>
                                        <Grid item>
                                            <Grid container gap="10px" direction={"column"}>
                                                <Grid item> <span className={styles.headingDetailsStyle}>Campaign Contacts</span> (<a className={style.contactListRedirectURL} href={`${window.location.origin}/contacts?contact_list_id=${selectedWhatsAppCampaign.contact_list_id}`} target="_blank">{selectedWhatsAppCampaign.contact_list_name}</a>) (<span className={style.contactListRedirectURL}>Contacts - {thousandSeparator(selectedWhatsAppCampaign.total_campaign_contact)}</span>)</Grid>
                                                <Grid item className={style.contactsSelectedInfo}><span>{contactTagActionData.preSelectedContacts.length} Contacts Selected</span></Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item>
                                            <Grid container gap="15px">
                                                <Grid item>
                                                    <Grid container alignItems={"center"} gap="10px">
                                                        <Grid item className={style.statusFilterTypography}>Filter by Status</Grid>
                                                        <Grid item>
                                                            <Autocomplete
                                                                sx={{ minWidth: "165px" }}
                                                                multiple
                                                                className={contactStyles.contactFilterDropDowns}
                                                                options={filterStatusOptions}
                                                                getOptionLabel={(option) => option}
                                                                value={filterByStatus}
                                                                PopperComponent={CustomPopper}
                                                                onChange={(_: React.SyntheticEvent, value: string[]) => { setFilterByStatus(value); onChangeOfFilterStatus('filterByStatus', value) }}
                                                                renderInput={params => {
                                                                    const { InputProps, ...restParams } = params;
                                                                    const { startAdornment, ...restInputProps } = InputProps;
                                                                    return (
                                                                        <TextField
                                                                            {...restParams}
                                                                            placeholder='Filter by Status'
                                                                            InputProps={{
                                                                                ...restInputProps,
                                                                                startAdornment: (
                                                                                    <div style={{
                                                                                        maxHeight: "79px",
                                                                                        overflowY: 'auto',
                                                                                    }}
                                                                                    >
                                                                                        {startAdornment}
                                                                                    </div>
                                                                                ),
                                                                            }}
                                                                        />
                                                                    );
                                                                }}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                <Grid item>
                                                    <GlobalButton buttonText="Bulk Action" className='primaryButtonStyle' onClick={() => { setContactTagActionData((prevState) => ({ ...prevState, flagOpenBulkAction: true })) }} />
                                                </Grid>
                                            </Grid>

                                        </Grid>
                                    </Grid>
                                </Grid>
                            }
                            {flagDashboardPage &&
                                <Grid item className={globalStyles.fullwidth}>
                                    <Typography className={styles.headingDetailsStyle}>
                                        {flagDashboardPage ?
                                            'Campaigns'
                                            : 
                                            'Campaign Contacts'
                                        }
                                    </Typography>
                                </Grid>
                            }
                            <Grid item className={`${globalStyles.fullwidth} ${style.campaignContactTableStyle}`} xs={12} lg={12}>
                                {flagDashboardPage ? 
                                        <CampaignListTable
                                            flagDashboardPage={true}
                                            campaignList={multipleCampaignsData?.campaign_data ?? []}
                                            tableInnerHeight={450}
                                        />
                                    :
                                        <CampaignAnalysisContacts
                                            tableData={selectedWhatsAppCampaign}
                                            contactTagActionData={contactTagActionData}
                                            onChangeOfFilterStatus={onChangeOfFilterStatus}
                                            statusColor={cardDetailsColor}
                                            flagDashboardPage={flagDashboardPage}
                                            setFlagAnalyticsStatus={setFlagAnalyticsStatus}
                                        />
                                }
                            </Grid>
                        </Grid>
                    </Grid>

                    {campaignContactStatusPopup &&
                        <GlobalPopUp
                            open={campaignContactStatusPopup}
                            onClose={() => { setCampaignContactStatusPopup(false); setFlagAnalyticsStatus(false) }}
                            // title={}
                            flagBackdrop
                            paperMinWidth={smallScreen ? "0" : "700px"}
                            paperMaxwidth={smallScreen ? "calc(100% - 32px)" : "750px"}
                            margin={smallScreen ? "16px" : undefined}
                            flagShowCloseIcon={true}
                            handleClose={() => { setCampaignContactStatusPopup(false); setFlagAnalyticsStatus(false) }}
                        >
                            <CampaignContactStatusTrack flagAnalyticsStatus={flagAnalyticsStatus} />
                        </GlobalPopUp>
                    }
                </Grid>}
            {contactTagActionData.flagOpenBulkAction &&
                <GlobalPopUp
                    flagShowCloseIcon
                    open={contactTagActionData.flagOpenBulkAction}
                    handleClose={() => {
                        setContactTagActionData(initialData);
                        setFilterByStatus([]);
                    }}
                    title={"Bulk Action"}
                    paperMinWidth={smallScreen ? "90%" : "700px"}
                    paperMaxwidth={smallScreen ? "750px" : "750px"}
                >
                    <ContactTagActionPopup 
                        handleClose={() => { setContactTagActionData(initialData) }} 
                        handleSaveAction={handleSaveAction} 
                        setFlagAddTagDialogObj={setFlagAddTagDialogObj} 
                        contactTagData={contactTagData} 
                        contactTagActionData={contactTagActionData} 
                        onChangeContactTagActionData={onChangeContactTagActionData}
                        onClickOfDeleteTag={onClickOfDeleteTag}
                    />
                </GlobalPopUp>}

            {tagDeleteConfirmation?.flagShowConfirmation && 
                <GlobalDeletePopup
                    deleteDescription={`Are you sure you want to delete ${tagDeleteConfirmation?.selectedTag?.contact_tag_name} tag`}
                    open={tagDeleteConfirmation?.flagShowConfirmation}
                    onClose={() => onCloseOfDeleteTagPopup()}
                    onDelete={() => deleteContactTagApiCall()}
                />
            }

            <GlobalPopUp

                open={flagAddTagDialogObj.flag}
                handleClose={() => handleCloseTagDialog()}
                onClose={() => handleCloseTagDialog()}
                flagShowCloseIcon={true}
                paperMinWidth={"600px"}
                paperMaxwidth={"650px"}
                borderRadius='10px'
                titlePadding='0px'
            >
                <AddNewTagPopup
                    flagAddTagDialogObj={flagAddTagDialogObj}
                    setFlagAddTagDialogObj={setFlagAddTagDialogObj}

                    setFlagEditContactDialog={setFlagEditContactDialog}
                    flagEditTag={flagAddTagDialogObj?.selectedTag ? true : false}
                    getListOfCampaignContactTagApiCall={getListOfCampaignContactTagApiCall}
                />
            </GlobalPopUp>
        </>

    )
}

export default CampaignAnalysis





